import React, { useState, useEffect } from 'react';
import { Row, Col, Modal } from "antd";
import { useSelector } from "react-redux";
import Content from "../../commons/components/content"
import ServiceUser from '../../services/users';
import ButtonAction from "../../commons/components/buttonAction";
import FindIcon from "../../commons/icons/findIcon";
import { TagTable } from "./styles"
import { TagTableExpanded } from "./styles"
import { SearchInput } from "./styles"
import AccountTable from "../../commons/components/AccountTable"
import Message from '../../commons/utils/message'

function UserPermissions() {

    const [search, setSearch] = useState("");
    const [loadingTable, setLoadingTable] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [permission, setPermission] = useState({})
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [tagDetail, setTagDetail] = useState(null);
    const userId = useSelector(state => state.userLogin.userData.id);
    const [totalRows, setTotalRows] = useState("");
    const [pagination, setPagination] = useState(
        {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '15', '20'],
        }
    );

    function getTableColumns() {
        let tableColumns = [
            {
                title: "Parceiro",
                dataIndex: "trading_name",
                key: "partner_id",
                sorter: false,
                width: '15%',
                ellipsis: true,
            },
            {
                title: 'Aplicações',
                dataIndex: 'applications',
                key: 'applications',
                width: '20%',
                ellipsis: true,
                render: (applications) => (
                    <div className="row" style={{ margin: '1px' }}>
                        {
                            applications.map((application, index) => {
                                return (
                                    <div key={index}>
                                        <TagTable>{application.f1}</TagTable>
                                        {   applications.key === tagDetail ?
                                            application.f2.map((role, index) => {
                                                return (
                                                    <TagTableExpanded key={index}>
                                                        {role}
                                                    </TagTableExpanded>
                                                )
                                            }) : null
                                        }
                                    </div>
                                )
                            }
                            )
                        }
                    </div>
                ),
            }
        ];
        tableColumns = [...tableColumns, {
            title: 'Ação',
            key: 'action',
            width: '5%',
            ellipsis: true,
            render: (permission) => (
                <div style={{ display: 'flex' }}>
                    <ButtonAction type={permission.key === tagDetail ? "view-focused" : "view"} text="Visualizar permissões"
                        callback={() => handleViewPermission(permission)} />
                    {permission.trading_name !== "GERAL" ? <ButtonAction type="delete" text="Desvincular permissões"
                        callback={() => handleDeletePermission(permission)} /> : null}
                </div>
            ),
        }]
        return tableColumns;
    };

    useEffect(() => {
        if (userId) {
            if (search.length === 0) {
                getPartnersApplicationAndRoles(pagination)
            }
        }
    }, [userId, search]);

    function getActiveApplications(data) {
        data.map((partner) => {
            partner.applications = partner.applications.filter(application => application.f3);
        });
        return data;
    }

    async function getPartnersApplicationAndRoles(pagination, search) {
        setLoadingTable(true);
        let response = await ServiceUser.getPartnersApplicationAndRolesByUserId(userId, search, pagination, totalRows)
        if (response) {
            setLoadingTable(false);

            const data = getActiveApplications(response.data.data);
            formatTable(data)
            setTotalRows(data.pagination)
            setPagination({ ...pagination, total: data.pagination });
        } else {
            setLoadingTable(false);
        }
    }

    function formatTable(data) {
        let array = [];
        data.forEach((partner) => {
            partner.trading_name = partner.trading_name === "PARCEIRO DEFAULT" ? "GERAL" : partner.trading_name;
            partner.id = partner.partner_id;
            partner.key = partner.partner_id;
            partner.applications.key = partner.partner_id;
            array.push(partner);
        })
        array.sort((a, b) => a.key - b.key);
        setTableData(array);
    }

    function handleOnChangeTable(pagination) {
        getPartnersApplicationAndRoles(pagination, search)
    }

    const renderTable = () => (
        <AccountTable
            columns={getTableColumns()}
            dataSource={tableData}
            pagination={pagination}
            loading={loadingTable}
            onChange={handleOnChangeTable}
        />
    );

    async function handleViewPermission(data) {
        data.key !== tagDetail ? setTagDetail(data.key) : setTagDetail(null);
    }

    function handleSearch(e) {
        setSearch(e.target.value);
        if (search.length > 2) {
            searchPermissions(search);
        }
        if (search.length <= 1) {
            getPartnersApplicationAndRoles(pagination)
        }
    }

    async function searchPermissions(search) {
        setLoadingTable(true);
        let response = await getPartnersApplicationAndRoles(pagination, search)
        if (response) {
            setLoadingTable(false);
            formatTable(response.data.data)
        }
    }

    function returnConfirmAction() {
        if (search !== "") {
            searchPermissions(search);
        } else {
            getPartnersApplicationAndRoles(pagination)
        }
    }

    function handleDeletePermission(data) {
        const permission = {
            'user_id': userId,
            'partner_id': data.partner_id,
            'environment': 'PROD'
        }
        setPermission(permission)
        setShowDeleteModal(true);
    }

    function handleCalcelDeleteApplication() {
        setShowDeleteModal(false);
    }

    function handleConfirmDeleteApplication() {
        setLoadingTable(true);
        remove(permission);
        setShowDeleteModal(false);
        setLoadingTable(false);
    }

    async function remove(data) {
        let response = await ServiceUser.unlink(data)
        if (response) {
            Message.showSuccess("Permissão desvinculada!")
            returnConfirmAction()
        }
    }

    const deletePermissionModal = () => (
        <Modal visible={showDeleteModal} title="Desvincular permissão"
            onCancel={handleCalcelDeleteApplication} cancelText="Cancelar" onOk={handleConfirmDeleteApplication} okText="Desvincular"
            okType="danger">
            <p>Tem certeza que deseja desvincular essas permissões?</p>
            <small><strong><p>Essa ação não poderá ser desfeita por você.<br></br>
                Apenas o responsável pelas permissões de sua empresa poderá liberá-las novamente.</p></strong></small>
        </Modal>
    );

    const renderHeader = () => (
        <Row style={{ display: "flex", alignItems: "center" }}>
            <Col span={20}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                        <h2 className={"dados-header"}>Minhas permissões</h2>
                    </div>
                </div>
            </Col>
            <Col span={4} style={{ textAlign: "right" }}>
                <SearchInput
                    placeholder="Pesquisar parceiro"
                    allowClear
                    onChange={handleSearch}
                    value={search}
                    prefix={<FindIcon />}
                />
            </Col>
        </Row>

    );

    return (
        <Content minHeight={360}>
            {deletePermissionModal()}
            {renderHeader()}
            {renderTable()}
        </Content>
    )

} export default UserPermissions